/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {Box} from "theme-ui";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    a: "a",
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(Box, {
    sx: {
      textAlign: "left"
    }
  }, React.createElement(_components.h3, {
    id: "launching-fall-2025"
  }, React.createElement(_components.a, {
    href: "#launching-fall-2025"
  }, "Launching fall 2025")), React.createElement(_components.p, null, "Drop your email and be one of the first to know when Scaling Fast launches in fall 2025"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
